import React from 'react';
import PropTypes from 'prop-types';

import { Image } from '$partials/media';
import {
    Player,
    PlayerEmbed,
    PlayerPlaceholder,
    PlayerPlayButton
} from '$partials/base/player.jsx';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ModuleVideoEmbed = ({
    caption,
    posterImage,
    html
}) => {
    return (
        <figure className='w-full flex flex-wrap my-44 md:my-70 md:flex-row-reverse'>
            <div className='w-full md:w-10/12 px-10 sm:px-20'>
                <Player
                    className='width-100'
                    shouldPrerender={true}
                    shouldToggleVisibility={posterImage ? true : false}>
                    <PlayerEmbed>
                        <div
                            className='video-oembed'
                            dangerouslySetInnerHTML={{ __html: html }} />
                    </PlayerEmbed>

                    {posterImage &&
                        <PlayerPlaceholder>
                            <PlayerPlayButton className='w-full block relative'>
                                <Image
                                    loadWidth={1162}
                                    {...posterImage} />
                                <div className='absolute top-0 left-0 w-full h-full flex justify-center items-center'>
                                    <svg
                                        fill='none'
                                        style={{ width: '48px', height: '48px' }}
                                        viewBox='0 0 48 48'
                                        xmlns='http://www.w3.org/2000/svg'>
                                        <g clipPath='url(#clip0_539_4839)'>
                                            <path
                                                d='M24 0C19.2533 0 14.6131 1.40758 10.6663 4.04473C6.71954 6.68188 3.64341 10.4302 1.8269 14.8156C0.0103989 19.201 -0.464881 24.0266 0.461164 28.6822C1.38721 33.3377 3.67299 37.6141 7.02945 40.9706C10.3859 44.327 14.6623 46.6128 19.3178 47.5388C23.9734 48.4649 28.799 47.9896 33.1844 46.1731C37.5698 44.3566 41.3181 41.2805 43.9553 37.3337C46.5924 33.3869 48 28.7468 48 24C47.9984 17.6353 45.4693 11.5317 40.9688 7.03119C36.4683 2.53067 30.3647 0.00159058 24 0ZM14 35.6L35.87 24.02L16 13.46V32.28L14 33.34V10.13L40.13 24.03L14 37.88V35.6Z'
                                                fill='white'/>
                                        </g>
                                        <defs>
                                            <clipPath id='clip0_539_4839'>
                                                <rect
                                                    fill='white'
                                                    height='48'
                                                    width='48'/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                            </PlayerPlayButton>
                        </PlayerPlaceholder>
                    }
                </Player>
            </div>

            {!!caption &&
                <figcaption className='w-full sm:w-4/6 md:w-2/12 type-style-7 text-dark-grey whitespace-pre-wrap mt-5 sm:mt-10 md:mt-0 px-10 sm:px-20'>
                    {caption}
                </figcaption>
            }
        </figure>
    );
};

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

ModuleVideoEmbed.propTypes = {
    caption: PropTypes.string,
    posterImage: PropTypes.object,
    html: PropTypes.string
};

export default ModuleVideoEmbed;
